import type { IData } from "../components/view-by-domain-chart/types";
import type { IDomainsData } from "../types";

export const transformDomainsData = (
    channelsData: IData,
    trafficSourcesMap: Record<string, { text: string; color: string }>,
): IDomainsData => {
    const transformedData: IDomainsData = {};

    Object.values(trafficSourcesMap).forEach(({ text }) => {
        transformedData[text] = {};
    });

    for (const channel in channelsData) {
        const { trafficSources } = channelsData[channel];

        for (const source in trafficSources) {
            const displaySource = trafficSourcesMap[source];
            if (displaySource && transformedData[displaySource.text]) {
                transformedData[displaySource.text][channel] = trafficSources[source];
            }
        }
    }

    return transformedData;
};
